import styled from 'styled-components';

/**
 * Styled components for Loader
 * Full-screen loading overlay with animated indicator
 */

export const LoaderContainer = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(2 0 36 / 47%);
  color: white;
  z-index: 100000;
  width: 100vw;
  height: 100vh;
  display: grid;
  align-items: center;
  justify-items: center;
`;

export const LoaderContent = styled.section`
  display: grid;
  justify-items: center;
`;

export const LoaderHeader = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 1rem;

  h1 {
    font-size: 1.7rem;
    color: #ffffff;
    padding: 0;
    margin-left: 0.5rem;
  }

  img {
    padding-bottom: 4px;
  }
`;

export const LoaderAnimation = styled.p`
  margin: 0;
`;
